import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Home from '@/views/Home.vue'
import Dom from '@/views/Dom.vue'
import PvHome from '@/views/PvHome.vue'
import Product from '@/views/Product.vue'
import Category from '@/views/Category.vue'
import Checkout from '@/views/Checkout.vue'
import Mpesa from '@/views/pay/Mpesa.vue'
import Status from '@/views/pay/Status.vue'


 


const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: '/',
    component: Home
  },
  {
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/category',
    name: 'Category',
    component: Category
  },
  {
    path: '/checkout',
    name: 'Checkout',
    component: Checkout
  },
  {
    path: '/mpesa',
    name: 'Mpesa',
    component: Mpesa
  },
  {
    path: '/status',
    name: 'Status',
    component: Status
  },
  {
    path: '/new/status',
    name: 'NewStatus',
    component: Status
  },
  {
    path: '/dom',
    name: 'Dom',
    component: Dom
  },
  {
    path: '/pv_home',
    name: 'pv_home',
    component: PvHome
  },
  {
    path: '/new/pv_home',
    name: 'new_pv_home',
    component: PvHome
  },
  {
    path: '/goods',
    name: 'Product',
    component: Product
  },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
  {
    path: '/seckill',
    name: 'seckill',
    component: () => import(/* webpackChunkName: "about" */ '@/components/home/seckill.vue')
  },
  {
    path: '/popular-categories',
    name: 'popular-categories',
    component: () => import(/* webpackChunkName: "about" */ '@/components/home/popular-categories.vue')
  },
  {
    path: '/product-list',
    name: 'product-list',
    component: () => import(/* webpackChunkName: "about" */ '@/components/home/product-list.vue')
  },
  {
    path: '/login',
    name: 'register',
    component: () => import(/* webpackChunkName: "about" */ '@/views/register/index.vue')
  },
  {
    path:'/findPwd',
    name:'forgotPassword',
    component:()=>import(/* webpackChunkName: "about" */ '@/views/forgotPassword/forgotPassword.vue')
  },
  {
    path: '/flashSale',
    name: 'seckill-down',
    component: () => import(/* webpackChunkName: "seckill-down" */ '@/views/seckill-down/index.vue')
  },
  {
    path: '/usercenter',
    name: 'usercenter',
    component: () => import(/* webpackChunkName: "usercenter" */ '@/views/personal-center/index.vue'),
  },
  {
    path: '/address-list',
    name: 'address-list',
    component: () => import(/* webpackChunkName: "address-list" */ '@/views/address-list/index.vue'),
    meta: {
      requireAuth: true
    },
  },
  {
    path: '/address-adds',
    name: 'address-adds',
    component: () => import(/* webpackChunkName: "address-add" */ '@/views/address-list/address-adds.vue')
  },
  {
    path: '/dom',
    name: 'dom',
    component: () => import(/* webpackChunkName: "address-list" */ '@/views/Dom.vue')
  },
  {
    path: '/province',
    name: 'province',
    component: () => import(/* webpackChunkName: "address-add" */ '@/views/address-list/children/province.vue')
  },
  {
    path: '/pickup',
    name: 'pickup',
    component: () => import(/* webpackChunkName: "address-add" */ '@/views/address-list/children/pickup.vue')
  },
  {
    path: '/historyView',
    name: 'historyView',
    component: () => import(/* webpackChunkName: "address-add" */ '@/views/HistoryView.vue'),
    meta: {
      requireAuth: true
    },
  },
  {
    path: '/favoriteGoods',
    name: 'favoriteGoods',
    component: () => import(/* webpackChunkName: "address-add" */ '@/views/FavoriteGoods.vue')
  },
  {
    path: '/savedShops',
    name: 'savedShops',
    component: () => import(/* webpackChunkName: "address-add" */ '@/views/SavedShops.vue')
  },
  {
    path: '/coinRewards',
    name: 'coinRewards',
    component: () => import(/* webpackChunkName: "address-add" */ '@/views/CoinRewards.vue')
  },
  {
    path: '/myVouchers',
    name: 'myVouchers',
    component: () => import(/* webpackChunkName: "address-add" */ '@/views/MyVouchers.vue')
  },

  {
    path: '/setting',
    name: 'setting',
    component: () => import(/* webpackChunkName: "setting" */ '@/views/personal-center/setting/index.vue')
  },
  {
    path: '/modify-email',
    name: 'modify-email',
    component: () => import(/* webpackChunkName: "setting" */ '@/views/personal-center/setting/modify-email.vue'),
    meta: {
      requireAuth: true
    },
  },
  {
    path: '/update-profile',
    name: "update-profile",
    component: () => import(/* webpackChunkName: "update-profile" */ '@/views/personal-center/setting/update-profile.vue'),
    meta: {
      requireAuth: true
    },
  },
  {
    path: '/interrested',
    name: 'interrested',
    component: () => import(/* webpackChunkName: "interrested" */ '@/views/personal-center/setting/interrested.vue'),
    meta: {
      requireAuth: true
    },
  },
  {
    path: '/my-profile',
    name: 'my-profile',
    component: () => import(/* webpackChunkName: "my-profile" */ '@/views/personal-center/setting/my-profile.vue'),
    meta: {
      requireAuth: true
    },
  },
  {
    path: '/search-middle',
    name: 'search',
    component: () => import(/* webpackChunkName: "search" */ '@/views/search/index.vue')
  },
  {
    path: '/search',
    name: 'search-listings',
    component: () => import(/* webpackChunkName: "search-listings" */ '@/views/search/search-listings.vue')
  },
  {
    path: '/search/:searchItem',
    name: 'search-item',
    component: () => import(/* webpackChunkName: "search-listings" */ '@/views/search/search-listings.vue')
  },
  {
    path: '/categorySearch/:gc_id',
    name: 'category-search',
    component: () => import(/* webpackChunkName: "search-listings" */ '@/views/search/search-listings.vue')
  },
  {
    path: '/shop/:id',
    name: 'shop',
    component: () => import(/* webpackChunkName: "shop" */ '@/views/shop/index.vue')
  },
  {
    path: '/store/:id',
    name: 'store',
    component: () => import(/* webpackChunkName: "shop" */ '@/views/shop/index.vue')
  },
  {
    path: '/shop-details',
    name: 'shop-details',
    component: () => import(/* webpackChunkName: "shop-details" */ '@/views/shop/children/shop-details.vue')
  },
  {
    path: '/shop-search',
    name: 'shop-search',
    component: () => import(/* webpackChunkName: "shop-search" */ '@/views/shop/children/shop-search.vue')
  },
  {
    path: '/shop-list',
    name: 'shop-list',
    component: () => import(/* webpackChunkName: "shop-list" */ '@/views/shop/children/shop-list.vue')
  },
  {
    path: '/modifyPassword',
    name: 'modifyPassword',
    component: () => import(/* webpackChunkName: "shop-search" */ '@/views/modifyPassword/modifyPassword.vue'),
    meta: {
      requireAuth: true
    },
  },
  {
    path: '/message',
    name: 'message',
    component: () => import(/* webpackChunkName: "message" */ '@/views/message/message.vue')
  },
  {
    path: '/cart',
    name: 'cart',
    component: () => import(/* webpackChunkName: "message" */ '@/views/cart/cart.vue')
  },
  {
    path: '/order',
    name: 'orders',
    component: () => import(/* webpackChunkName: "message" */ '@/views/order/order-list.vue'),
    meta: {
      requireAuth: true
    },
  },
  {
    path: '/goods/:id',
    name: 'goods',
    component: () => import(/* webpackChunkName: "goods" */ '@/views/goods/index.vue')
  },
  {
    path: '/paid/:id',
    name: 'Paid',
    component: () => import(/* webpackChunkName: "goods" */ '@/views/pay/paid.vue')
  },
  {
    path: '/comment-list',
    name: 'comment-list',
    component: () => import(/* webpackChunkName: "goods" */ '@/views/goods/comment-list.vue')
  },

  {
    path: '/orderDetails',
    name: 'orderDetails',
    component: () => import(/* webpackChunkName: "goods" */ '@/views/order/orderDetails.vue'),
    meta: {
      requireAuth: true
    },
  },
  {
    path: '/help',
    name: "help",
    component: () => import(/* webpackChunkName: "helps" */ '@/views/help/index.vue'),
  },
  {
    path: '/policy',
    name: "app_policy",
    component: () => import(/* webpackChunkName: "help" */ '@/views/help/policy.vue'),
  },
  {
    path: '/policy/:id',
    name: "policy",
    component: () => import(/* webpackChunkName: "help" */ '@/views/help/policy.vue'),
  },
  {
    path: '/helpIII/:id',
    name: "helpIII",
    component: () => import(/* webpackChunkName: "help" */ '@/views/help/policy.vue'),
  },
  {
    path: '/novice_rule',
    name: "novice_rule",
    component: () => import(/* webpackChunkName: "help" */ '@/views/help/novice_rule.vue'),
  },
  {
    path: '/orderquery',
    name: 'orderquery',
    component: () => import('@/views/logistics/orderQuery.vue')
  },
  {
    path: '/logistics/:orderNum',
    name: 'logistics',
    component: () => import('@/views/logistics/index.vue')
  },
  {
    path: '/pickupDetail/:id',
    name: 'pickupDetail',
    component: () => import('@/views/logistics/pickupDetail.vue')
  },
  {
    path: '/liteLogistics/:orderNum',
    name: 'liteLogistics',
    component: () => import('@/views/liteLogistics/index.vue')
  },
  {
    path: '/litePickupDetail/:id',
    name: 'litePickupDetail',
    component: () => import('@/views/liteLogistics/pickupDetail.vue')
  },
  {
    path: '/barginshare',
    name: 'BargainShare',
    component: () => import('@/views/BargainShare.vue')
  },
  {
    path: '/bargainrule',
    name: 'BargainRule',
    component: () => import('@/views/BargainRule.vue')
  },
  {
    path: '/tunetable',
    name: 'Tunetable',
    component: () => import('@/views/tunetable/index.vue')
  },
  {
    path: '/tunetableComment',
    name: 'TunetableComment',
    component: () => import('@/views/tunetable/commentSubmit.vue')
  },
  {
    path: '/Subscription',
    name: 'Subscription',
    component: () => import('@/views/subscription/Subscription.vue')
  },
  {
    path: '/systemSubscription',
    name: 'systemSubscription',
    component: () => import('@/views/subscription/systemSubscription.vue')
  },
  {
    path: '/UnSubscription',
    name: 'UnSubscription',
    component: () => import('@/views/subscription/UnSubscription.vue')
  },
  {
    path: '/ShareSafari/:id',
    name: 'ShareSafari',
    component: () => import('@/views/shareSafari/index.vue')
  },
  {
    path: '/afterSale',
    name: 'afterSale',
    meta: {
      requireAuth: true
    },
    component: () => import(/* webpackChunkName: "afterSale" */  '@/views/afterSale/index.vue')
  },
  {
    path: '/afterSaleType/:id',
    name: 'afterSaleType',
    component: () => import(/* webpackChunkName: "afterSale" */  '@/views/afterSale/afterSaleType.vue')
  },
  {
    path: '/afterSaleInfo/:id?',
    name: 'afterSaleInfo',
    component: () => import(/* webpackChunkName: "afterSale" */  '@/views/afterSale/afterSaleInfo.vue')
  },
  {
    path: '/afterSaleDetails/:id',
    name: 'afterSaleDetails',
    component: () => import(/* webpackChunkName: "afterSale" */  '@/views/afterSale/afterSaleDetails.vue')
  },
  {
    path: '/afterSaleDetailsNew/:id',
    name: 'afterSaleDetailsNew',
    component: () => import(/* webpackChunkName: "afterSale" */  '@/views/afterSale/afterSaleDetailsNew.vue')
  },
  {
    path: '/afterSaleLogInfo/:id',
    name: 'afterSaleLogInfo',
    component: () => import(/* webpackChunkName: "afterSale" */  '@/views/afterSale/afterSaleLogInfo.vue')
  },
  {
    path: '/afterSaleComplaint/:id',
    name: 'AfterSaleComplaint',
    component: () => import(/* webpackChunkName: "afterSale" */  '@/views/afterSale/afterSaleComplaint.vue')
  },
  {
    path: '/afterSaleExpress',
    name: 'afterSaleExpress',
    component: () => import(/* webpackChunkName: "afterSale" */  '@/views/afterSale/afterSaleExpress.vue')
  },
  {
    path: '/afterSaleEvaluation/:id',
    name: 'afterSaleEvaluation',
    component: () => import(/* webpackChunkName: "afterSale" */  '@/views/afterSale/afterSaleEvaluation.vue')
  },
  {
    path: '/afterSaleRule',
    name: 'afterSaleRule',
    component: () => import(/* webpackChunkName: "afterSale" */  '@/views/afterSale/afterSaleRule.vue')
  },
  {
    path: '/closeaccount',
    name: 'CloseAccount',
    component: () => import(/* webpackChunkName: "afterSale" */  '@/views/logout-account/CloseAccount.vue')
  },
  {
    path: '/voucher/:id',
    name: 'Voucher',
    component: () => import(/* webpackChunkName: "afterSale" */  '@/views/voucher/index.vue')
  },


]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})
router.beforeEach((to: any, from: any, next) => {
  let token = localStorage.getItem('access_token')
  let kongToken = localStorage.getItem('kong_access_token')
  window.scrollTo(0, 0)
  if (!to.matched.length) {
    next('/home');
  } else {
    if (to.matched.some((res: any) => res.meta.requireAuth)) {
      if (token || kongToken) {
        next();
      } else {
        next({
          path: "/login"
        });
      }
    } else {
      next();
    }
  }


});

export default router
